module.exports = __webpack_public_path__ + "static/media/HomeGraphic5.63b831ec.jpg";